import { colorsPalettes } from "@similarweb/styles";
import { PlainTooltip } from "@similarweb/ui-components";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { InfoTooltip } from "app/components/React/Tooltip/InfoTooltip/InfoTooltip";

const SEGMENT_COUNT = 5;
const SEGMENT_INDICES = Array.from({ length: SEGMENT_COUNT }, (_, index) => index);

interface ISegmentedScaleProps {
    label: string;
    tooltipText: string;
    leftLabel: string;
    rightLabel: string;
    segmentLabels: string[];
    filledIndex: number;
    dataAutomation: string;
}

export const SegmentedScale = ({
    label,
    tooltipText,
    leftLabel,
    rightLabel,
    segmentLabels,
    filledIndex,
    dataAutomation,
}: ISegmentedScaleProps) => (
    <Flex
        alignItems="center"
        gap="12px"
        data-automation={dataAutomation}
    >
        <Flex
            alignItems="center"
            gap="4px"
            width="140px"
            flexShrink={0}
        >
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[500]}
                whiteSpace="nowrap"
            >
                {label}
            </Text>
            <InfoTooltip infoText={tooltipText} />
        </Flex>
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[400]}
            width="64px"
            flexShrink={0}
            whiteSpace="nowrap"
        >
            {leftLabel}
        </Text>
        <Flex flex="1" />
        <Flex
            gap="6px"
            flexShrink={0}
        >
            {SEGMENT_INDICES.map((index) => (
                <PlainTooltip
                    key={index}
                    tooltipContent={segmentLabels[index]}
                    placement="top"
                >
                    <Box
                        width="12px"
                        height="12px"
                        borderRadius="4px"
                        background={index === filledIndex ? colorsPalettes.blue[400] : colorsPalettes.carbon[100]}
                        data-automation={`${dataAutomation}-segment-${index}`}
                    />
                </PlainTooltip>
            ))}
        </Flex>
        <Flex flex="1" />
        <Text
            fontVariant="caption"
            color={colorsPalettes.carbon[400]}
            width="64px"
            flexShrink={0}
            whiteSpace="nowrap"
            textAlign="right"
        >
            {rightLabel}
        </Text>
    </Flex>
);
